export const RecommendedService = [
  {
    title: "Instagram Followers [Cheapest - 3K Day]",
    price: "0.08",
    count: "1.000",
  },
  {
    title: "Instagram Followers [Cheapest - 3K Day]",
    price: "0.08",
    count: "1.000",
  },
  {
    title: "Instagram Followers [Cheapest - 3K Day]",
    price: "0.08",
    count: "1.000",
  },
  {
    title: "Instagram Followers [Cheapest - 3K Day]",
    price: "0.08",
    count: "1.000",
  },
  {
    title: "Instagram Followers [Cheapest - 3K Day]",
    price: "0.08",
    count: "1.000",
  },
  {
    title: "Instagram Followers [Cheapest - 3K Day]",
    price: "0.08",
    count: "1.000",
  },
  {
    title: "Instagram Followers [Cheapest - 3K Day]",
    price: "0.08",
    count: "1.000",
  },
];
